import { AlertCircle } from 'lucide-react';
import type { Cita } from '../../types';
import { TarjetaCita, TarjetaCitaPasada } from './TarjetaCita';

interface Props {
  citasProximas: Cita[];
  citasPasadas: Cita[];
  onEditar: (cita: Cita) => void;
  onEliminar: (id: string) => void;
  onSilenciar: (cita: Cita) => void;
}

export function ListaCitas({
  citasProximas,
  citasPasadas,
  onEditar,
  onEliminar,
  onSilenciar,
}: Props) {
  return (
    <>
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
          <AlertCircle className="text-green-600" size={24} />
          Próximas Citas ({citasProximas.length})
        </h2>
        {citasProximas.length === 0 ? (
          <div className="bg-white rounded-xl shadow-lg p-8 text-center text-gray-500">
            No tienes citas programadas
          </div>
        ) : (
          <div className="space-y-4">
            {citasProximas.map((cita) => (
              <TarjetaCita
                key={cita.id}
                cita={cita}
                onEditar={onEditar}
                onEliminar={onEliminar}
                onSilenciar={onSilenciar}
              />
            ))}
          </div>
        )}
      </div>

      {citasPasadas.length > 0 && (
        <div>
          <h2 className="text-xl font-bold text-gray-500 mb-4">
            Citas Pasadas ({citasPasadas.length})
          </h2>
          <div className="space-y-4">
            {citasPasadas.map((cita) => (
              <TarjetaCitaPasada key={cita.id} cita={cita} onEliminar={onEliminar} />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
